import { createSlice } from '@reduxjs/toolkit';
import { buildFailedAsyncData, buildStartedAsyncData, buildSucceededAsyncData, buildUnitializedAsyncData } from 'reporting-data/asyncData/AsyncData';
import { getId as getReportId
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/report/report-schema';
import { getDashboardReports
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/dashboard/dashboard-logic';
import { appliedDashboardFiltersActions } from '../applied-dashboard-filters/slice';
import { getOverriddenReportsFromAPIThunk } from './thunks';
import { getAppliedFiltersByReportFromDashboard, setAsyncState, resetAsyncStateOnFiltersChanged } from './helpers';
import { fromJS } from 'immutable';
export const dashboardReportsNamespace = 'dashboardReports';
export const initialState = {
  dashboardReports: {}
};
const dashboardReportsSlice = createSlice({
  name: dashboardReportsNamespace,
  initialState,
  reducers: {
    initializeDashboardReports: (state, action) => {
      const {
        payload: {
          dashboard
        }
      } = action;
      const dashboardId = dashboard.id;
      const dashboardReports = getDashboardReports(fromJS(dashboard));
      const initialReportsConfig = dashboardReports.reduce((nextDashboardReports, reportConfig) => {
        const reportId = getReportId(reportConfig);
        nextDashboardReports[reportId] = reportConfig;
        return nextDashboardReports;
      }, {});
      state.dashboardReports[dashboardId] = {
        asyncState: buildUnitializedAsyncData(),
        reports: initialReportsConfig,
        appliedFiltersByReport: getAppliedFiltersByReportFromDashboard(dashboard)
      };
    },
    deleteReport: (state, action) => {
      var _state$dashboardRepor;
      const {
        payload: {
          dashboardId,
          reportId
        }
      } = action;
      if ((_state$dashboardRepor = state.dashboardReports[dashboardId]) !== null && _state$dashboardRepor !== void 0 && _state$dashboardRepor.reports[reportId]) {
        delete state.dashboardReports[dashboardId].reports[reportId];
      }
    }
  },
  extraReducers(builder) {
    builder.addCase(appliedDashboardFiltersActions.addDashboardFilter, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.addGroupDashboardFilter, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.updateDashboardFilter, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.removeDashboardFilter, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.removeCurrentDashboardFilters, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.removeDashboardFilterByName, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.removeGroupDashboardFilter, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.initializeDashboardFilters, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.removeAllDashboardFilters, state => {
      Object.keys(state.dashboardReports).forEach(dashboardId => {
        resetAsyncStateOnFiltersChanged(state, {
          payload: {
            dashboardId: Number(dashboardId)
          }
        });
      });
    }).addCase(appliedDashboardFiltersActions.updateFrequency, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    }).addCase(appliedDashboardFiltersActions.updateFrequencyUseFiscalYear, (state, action) => {
      resetAsyncStateOnFiltersChanged(state, action);
    });
    builder.addCase(getOverriddenReportsFromAPIThunk.pending, (state, action) => {
      const {
        arg: {
          dashboardId
        }
      } = action.meta;
      setAsyncState(state, dashboardId, buildStartedAsyncData());
    }).addCase(getOverriddenReportsFromAPIThunk.rejected, (state, action) => {
      const {
        meta: {
          arg: {
            dashboardId
          }
        },
        payload: error
      } = action;
      setAsyncState(state, dashboardId, buildFailedAsyncData(error));
    }).addCase(getOverriddenReportsFromAPIThunk.fulfilled, (state, action) => {
      const {
        meta: {
          arg: {
            dashboardId
          }
        },
        payload: dashboard
      } = action;
      const dashboardReports = getDashboardReports(dashboard);
      const overriddenReportsConfig = dashboardReports.reduce((nextDashboardReports, reportConfig) => {
        const reportId = getReportId(reportConfig);
        nextDashboardReports[reportId] = reportConfig;
        return nextDashboardReports;
      }, {});
      state.dashboardReports[dashboardId] = {
        asyncState: buildSucceededAsyncData(true),
        appliedFiltersByReport: getAppliedFiltersByReportFromDashboard(dashboard),
        reports: overriddenReportsConfig
      };
    });
  }
});
export const dashboardReportsActions = dashboardReportsSlice.actions;
export const dashboardReportsReducer = dashboardReportsSlice.reducer;